/*! react-loader v0.6.1 | (c) 2017 Trend Micro Inc. | MIT | https://github.com/trendmicro-frontend/react-loader */
module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 1);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _class, _temp;

  var _propTypes = __webpack_require__(4);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _react = __webpack_require__(5);

  var _react2 = _interopRequireDefault(_react);

  var _classnames = __webpack_require__(3);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _index = __webpack_require__(2);

  var _index2 = _interopRequireDefault(_index);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Loader = (_temp = _class = function (_PureComponent) {
    _inherits(Loader, _PureComponent);

    function Loader() {
      _classCallCheck(this, Loader);

      return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
    }

    _createClass(Loader, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            size = _props.size,
            overlay = _props.overlay,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['size', 'overlay', 'className']);

        return _react2.default.createElement('div', _extends({}, props, {
          className: (0, _classnames2.default)(className, _index2.default.loaderContainer, _defineProperty({}, _index2.default.loaderOverlay, overlay))
        }), _react2.default.createElement('i', {
          className: (0, _classnames2.default)(_index2.default.loader, _defineProperty({}, _index2.default.large, size === 'large' || size === 'lg'), _defineProperty({}, _index2.default.medium, size === 'medium' || size === 'md'), _defineProperty({}, _index2.default.small, size === 'small' || size === 'sm'))
        }));
      }
    }]);

    return Loader;
  }(_react.PureComponent), _class.propTypes = {
    size: _propTypes2.default.oneOf(['lg', 'md', 'sm', 'large', 'medium', 'small']),
    overlay: _propTypes2.default.bool
  }, _class.defaultProps = {
    size: 'md',
    overlay: false
  }, _temp);
  exports.default = Loader;
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var _Loader = __webpack_require__(0);

  var _Loader2 = _interopRequireDefault(_Loader);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  module.exports = _Loader2.default;
  /***/
},
/* 2 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "loader-container": "loader---loader-container---3z9L3",
    "loaderContainer": "loader---loader-container---3z9L3",
    "loader": "loader---loader---3Kv7h",
    "spinner": "loader---spinner---2cR6i",
    "small": "loader---small---lG1lQ",
    "medium": "loader---medium---3uYbD",
    "large": "loader---large----MUQK",
    "loader-overlay": "loader---loader-overlay---IQP-L",
    "loaderOverlay": "loader---loader-overlay---IQP-L"
  };
  /***/
},
/* 3 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
}
/******/
]);